/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
/**
 * TemplateStyles
 *
 * @file TemplateStyles.jsx
 * @author Mohamed yasar arabath M
 * @since 1.0.0
 */

import { makeStyles } from '@material-ui/core';
import mixins from '../../../assets/styles/mixins.scss';


const useTemplateStyles = makeStyles(() => ({
  contentTemplate: {
    display: 'flex',
    justifyItems: 'center',
    alignItems: 'center',
    boxSizing: 'border-box'
  },
  textContainer: {
    padding: '0 8px',
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    alignItems: 'flex-start',
    flex: 1,
    position: 'relative',
    boxSizing: 'border-box'
  },
  titleWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between'
  },
  titleText: {
    color: mixins.color_text_primary,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize16,
    lineHeight: '22px',
    fontWeight: mixins.fontWeight600,
    display: 'flex',
    alignItems: 'center'
  },
  sectionsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    gap: 4,
    alignItems: 'center',
    overflowX: 'auto',
    marginTop: 2
  },
  sectionsLabel: {
    color: mixins.greyScaleColor,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize12,
    fontWeight: mixins.fontWeight500,
    display: 'flex',
    alignItems: 'center',
    lineHeight: '20px'
  },
  sectionChip: {
    background: mixins.feedBackColor,
    borderRadius: 4,
    padding: '0 2px',
    display: 'flex',
    alignItems: 'center',
    marginRight: 2
  },
  chipContent: {
    padding: '0 4px 2px 4px',
    height: 20,
    gap: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  sectionNumber: {
    color: mixins.greyScaleColor,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize12,
    lineHeight: '20px',
    fontWeight: mixins.fontWeight500,
    display: 'flex',
    alignItems: 'center'
  },
  editActionIconButton: {
    padding: 8,
    minWidth: 0,
    margin: 0,
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    textTransform: 'none',
    alignSelf: 'center',
    '&:hover': {
      background: mixins.secondaryButtonHoverColor
    },
    '&:focus': {
      background: 'none'
    },
    '&:active': {
      background: 'none'
    },
    '&.editActionIcon': {
      visibility: 'hidden'
    }
  },
  titleTextContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
    justifyContent: 'space-between',
    width: '100%'
  },
  container: {
    position: 'relative',
    width: '100%'
  },
  errorInfoIcon: {
    fontSize: 18,
    cursor: 'pointer'
  },
  dateWarningIcon: {
    fontSize: 20,
    color: '#B45309',
    cursor: 'pointer'
  },
  statusColumnText: {
    color: mixins.color_text_primary,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize14,
    lineHeight: '20px',
    fontWeight: mixins.fontWeight400
  },
  editIconAlwaysVisible: {
    visibility: 'visible !important'
  },
  editActionIconContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  dateColumn: {
    display: 'flex',
    gap: 8
  }
}));

export default useTemplateStyles;
